<template>
    <div class="nav">
        <picture-cen-app></picture-cen-app>
    </div>
</template>

<script>
import PictureCenApp from '../scheme/picture-cen-app.vue'
    export default {
        name: "scheme-app",
        components:{
                PictureCenApp
        }
    }
</script>

<style scoped>
    .nav{
        /*background-color: #fff;*/
    }
</style>
